export { PLAN_TYPE } from '@shared/ui';

export enum PLAN_LOCK_FEATURE {
    CUSTOM_DOMAIN = 'custom_domain',
    CUSTOM_URL_SLUG = 'custom_url_slug',
    CUSTOM_META_TAGS = 'custom_meta_tags',
    CUSTOM_PAGE = 'custom_page',
    STOCK_THRESHOLD = 'stock_threshold',
    PRIVATE_PRODUCT = 'private_product',
    DELAYED_SALE = 'delayed_sale',
    DELAYED_LISTING = 'delayed_listing',
    PRODUCT_DESCRIPTION = 'product_description',
    BATCH_UPDATE_PRODUCT = 'batch_update_product',
    ORDER_TAG = 'order_tag',
    ORDER_SHIPPING_TICKET = 'order_shipping_ticket',
    ORDER_PICKUP_TICKET = 'order_pickup_ticket',
    ORDER_EXPORT_CSV = 'order_export_csv',
    INVOICE = 'invoice',
    COUPON = 'coupon',
    PROMO = 'promo',
    PROMO_DATETIME = 'promo_datetime',
    GIVEAWAY = 'giveaway',
    PROMO_AUTO_DISTRIBUTE = 'promo_auto_distribute',
    ACCOUNT_COUNT = 'account_count',
    MEDIA_UPLOAD_COUNT = 'media_upload_count',
    COMPONENT_SEARCH_BAR = 'component_search_bar',
    COMPONENT_TYPING_SUGGESTION = 'component_typing_suggestion',
}
